import { render, staticRenderFns } from "./CreateLectureForm.vue?vue&type=template&id=c37d5c70&scoped=true&"
import script from "./CreateLectureForm.vue?vue&type=script&lang=js&"
export * from "./CreateLectureForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateLectureForm.vue?vue&type=style&index=0&id=c37d5c70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37d5c70",
  null
  
)

export default component.exports